<ng-container [formGroup]="formGroup">
    <div class="table-row row gx-2 gy-0 p-2">
        <div class="col-12 text-center fw-semibold py-1">{{ document.title }}</div>
        <div class="col-auto">
            <div class="checkbox-container">
                <input
                    type="checkbox"
                    class="form-control"
                    #checkbox
                    id="document-select-checkbox"
                    formControlName="checkbox"
                    (click)="selectDocument()"
                    [attr.aria-label]="'DOCBOX_SELECT_DOC_ARIA_LABEL' | translate"
                />
                <fa-icon
                    *ngIf="document.isFileSelected"
                    [icon]="faCheck"
                    size="2x"
                    (click)="checkbox.click()"
                ></fa-icon>
            </div>
            <div class="text-center py-3" (click)="toggleExpanded()">
                <fa-icon [icon]="faChevronRight" *ngIf="!isExpanded"></fa-icon>
                <fa-icon [icon]="faChevronDown" *ngIf="isExpanded"></fa-icon>
            </div>
        </div>
        <div class="col">
            <div class="g-2 row">
                <div class="col-6">
                    <span class="type-icon" *ngIf="document.docType">
                        <fa-icon [icon]="document.docType | docBoxListIcon"></fa-icon>
                    </span>
                    {{ document.docType }}
                </div>
                <div class="col-6" *ngIf="document.date">{{ document.date }}</div>
                <div class="col-12 col-sm-6 col-lg-4" *ngIf="document.createdBy">{{ document.createdBy }}</div>
                <div class="col-12 col-sm-6 col-lg-4" *ngIf="document.reportStatus">
                    <span class="me-2 col-form-label" translate="DOCBOX_REPORT_STATUS_LABEL"></span>
                    {{ document.reportStatus }}
                </div>
                <div class="col-12 col-sm-6 col-lg-4" *ngIf="document.printNumber && isExpanded">
                    {{ document.printNumber }}
                </div>
                <div class="col-12 col-sm-6 col-lg-4" *ngIf="document.orderNumber && isExpanded">
                    {{ document.orderNumber }}
                </div>
                <div class="col-12 col-sm-6 col-lg-4" *ngIf="document.fileType && isExpanded">
                    {{ document.fileType }}
                </div>
            </div>
        </div>
        <div class="col-auto d-flex flex-column gap-2">
            <button
                class="btn btn-small btn-secondary"
                *ngIf="enableIndividualDownload"
                (click)="downloadDocument()"
                [attr.aria-label]="'DOCBOX_DOWNLOAD_DOCUMENT_TOOLTIP' | translate"
            >
                <fa-icon [icon]="faSave"></fa-icon>
            </button>
            <button
                class="btn btn-small btn-secondary"
                placement="left"
                (click)="uploadForEntry()"
                [attr.aria-label]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP' | translate"
            >
                <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
            </button>
        </div>
    </div>
</ng-container>
